<footer
    class="mt-20 w-full px-6 py-3 text-sm text-neutral-400"
    [innerHTML]="copyrights"
></footer>
